"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadOptions = exports.AutofocusValues = exports.AutofocusToggle = exports.SemicolonDelimitedRegimeKeyString = exports.DOMElementId = exports.IntegerString = exports.ThemeKey = exports.VariantKey = exports.RegimeKey = void 0;
const t = __importStar(require("io-ts"));
const type_utils_1 = require("@transcend-io/type-utils");
const internationalization_1 = require("@transcend-io/internationalization");
const consentUiTheme_1 = require("./consentUiTheme");
const consentUiConfiguration_1 = require("./consentUiConfiguration");
/**
 * Types representing the top-level consent UI configuration
 * Includes keys for regimes, variants, and themes
 */
/** Key representing a specific regime */
exports.RegimeKey = t.string;
/** Key representing a specific consent UI variant */
exports.VariantKey = t.string;
/** Key representing a specific theme */
exports.ThemeKey = t.string;
/** String that represents an integer value */
exports.IntegerString = t.string;
/** String that represents a DOM element ID */
exports.DOMElementId = t.string;
/** String that represents a semicolon-delimited list of regime keys */
exports.SemicolonDelimitedRegimeKeyString = t.string;
/**
 * Autofocus toggle values ("on" / "off").
 */
exports.AutofocusToggle = (0, type_utils_1.makeEnum)({
    /** Enable autofocus */
    On: 'on',
    /** Disable autofocus */
    Off: 'off',
});
/**
 * All valid autofocus values:
 * - `"on"` / `"off"`
 * - or a DOM element ID string
 */
exports.AutofocusValues = t.union([
    (0, type_utils_1.valuesOf)(exports.AutofocusToggle),
    exports.DOMElementId,
]);
/** The top-level configuration for the consent UI */
exports.LoadOptions = t.intersection([
    t.type({
        regimeVariantMap: t.record(exports.RegimeKey, exports.VariantKey),
        regimeAutoPromptMap: t.record(exports.RegimeKey, t.boolean),
        variantConfigMap: t.record(exports.VariantKey, consentUiConfiguration_1.UIConfiguration),
        variantThemeMap: t.record(exports.VariantKey, exports.ThemeKey),
        themeConfigMap: t.record(exports.ThemeKey, consentUiTheme_1.ThemeConfiguration),
        autofocus: exports.AutofocusValues,
        uiZIndex: exports.IntegerString,
        css: consentUiConfiguration_1.AbsoluteUrlString,
        // If messageMap is not defined, messages will be fetched from `${messageFolder}/${localeKey}.json`
        messageFolder: consentUiConfiguration_1.AbsoluteUrlString,
        regimePrecedence: exports.SemicolonDelimitedRegimeKeyString, // e.g. 'GDPR;CPRA;nFADP'
        supportedLanguages: t.array((0, type_utils_1.valuesOf)(internationalization_1.LOCALE_KEY)),
    }),
    t.partial({
        // if message map is defined, it will be used to retrieve localized messages
        messageMap: t.record((0, type_utils_1.valuesOf)(internationalization_1.LOCALE_KEY), consentUiConfiguration_1.AbsoluteUrlString),
    }),
]);
//# sourceMappingURL=consentUi.js.map